export const truncate = (str, length, suffix) => {
  suffix = suffix || '...';
  if (!length || !str || length >= str.length) {
    return str;
  }

  let output = str.substr(0, length);
  const lastSpace = output.lastIndexOf(' ');
  if (lastSpace > -1) {
    output = output.substring(0, lastSpace);
  }
  return output + suffix;
};

export const kebab = (str) => str.replace(/[\s_]+/g, '-').toLowerCase();

export const isExternalInstall = (installUrl) =>
  /^(https:\/\/hootsuite.com\/dashboard#\/app-details\?id\=|https:\/\/hootsuite.com\/login\?redirect=%2Fdashboard%23%2Fapp-details%3Fid%3D)/.test(
    installUrl,
  )
    ? false
    : true;

export const getButtonLabel = (installUrl) =>
  isExternalInstall(installUrl)
    ? /^https:\/\/hootsuite.com\/\.*/.test(installUrl)
      ? 'Contact Us'
      : 'Learn More'
    : 'Install';
